<template>
  <a-space>
    <span style="font-size: 14px; color: #888; font-weight: 500;">Status:</span>
    <a-dropdown>
      <template #overlay>
        <a-menu @click="onStatusChange">
          <a-menu-item key="enabled">
            <span class="dot green"></span> Enabled
          </a-menu-item>
          <a-menu-item key="disabled">
            <span class="dot red"></span> Disabled
          </a-menu-item>
        </a-menu>
      </template>
      <a-button :style="statusStyle">
        <span :style="dotStyle"></span>
        {{ statusText }}
        <DownOutlined />
      </a-button>
    </a-dropdown>
  </a-space>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { DownOutlined } from '@ant-design/icons-vue'

const status = ref('enabled')
const statusText = computed(() => {
  if (status.value === 'enabled') return 'Enabled'
  if (status.value === 'disabled') return 'Disabled'
})

const statusStyle = computed(() => ({
  background: status.value === 'enabled' ? '#f6ffed' : '#fff1f0',
  color: status.value === 'enabled' ? '#389e0d' : '#cf1322',
  borderRadius: '999px',
  fontWeight: 600,
  minWidth: '110px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}))

const dotStyle = computed(() => ({
  display: 'inline-block',
  width: '10px',
  height: '10px',
  borderRadius: '50%',
  marginRight: '8px',
  background: status.value === 'enabled' ? '#52c41a' : '#ff4d4f'
}))

const onStatusChange = ({ key }: { key: string }) => { status.value = key }
</script>

<style scoped>
.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 8px;
}
.dot.green { background: #52c41a; }
.dot.red { background: #ff4d4f; }
</style> 